import React from 'react';
import { Dialog } from '@/components/ui/dialog';

/**
 * Props for the ConvertToGuest component
 */
interface ConvertToGuestProps {
  /** Whether the dialog is open */
  open: boolean;
  /** Function to call when the dialog is closed */
  onClose: () => void;
  /** Function to call when conversion is confirmed */
  onConfirm: (additionalData: Record<string, unknown>) => Promise<void>;
  /** ID of the target guest to convert */
  targetGuestId: string;
}

/**
 * ConvertToGuest Component
 * 
 * Dialog component for converting a target guest to a regular guest.
 * 
 * @param props - Component props
 * @returns React component
 */
const ConvertToGuest: React.FC<ConvertToGuestProps> = ({ 
  open, 
  onClose, 
  onConfirm, 
  targetGuestId 
}) => {
  const handleConfirm = () => {
    // In a real implementation, we would collect additional data from form fields
    const additionalData: Record<string, unknown> = {
      convertedAt: new Date().toISOString(),
      status: 'confirmed'
    };
    
    onConfirm(additionalData);
  };
  
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <div className="p-6">
        <h2 className="text-lg font-semibold mb-4">Convert to Guest</h2>
        <p className="mb-4">
          Are you sure you want to convert this target guest to a regular guest?
          This will create a new guest record and mark the target guest as converted.
        </p>
        <div className="flex justify-end gap-2">
          <button 
            className="px-4 py-2 border border-gray-300 rounded-md hover:bg-gray-50"
            onClick={onClose}
          >
            Cancel
          </button>
          <button 
            className="px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700"
            onClick={handleConfirm}
          >
            Convert
          </button>
        </div>
      </div>
    </Dialog>
  );
};

export default ConvertToGuest;
